import React, { useCallback } from 'react';
import GCLPieChartTemplate1 from './LegalCompliance/GCLPieChartTemplate1';

export default function ModuleWidgetTemplateSwitch({ module }) {
  const renderTemplate = useCallback(() => {
    switch (module.cover?.type) {
      case 'gclpie1':
        return <GCLPieChartTemplate1 module={module} />;
      default:
        return null;
    }
  }, [module]);

  return renderTemplate();
}
